const bundle = {
  close: () => 'Cerrar',
  error: () => 'Error',
  warn: () => 'Advertencia',
  info: () => 'Información',
  confirmation: () => 'Confirmación',
  progressIndeterminate: () => 'En curso',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' y ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. No se ha encontrado ninguna sección que coincida.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Entre para seleccionar valor.',
  indexer_touchInstructionText: () =>
    'Toque dos veces y mantenga pulsado para cambiar a modo de gestos y, a continuación, arrastre hacia arriba o hacia abajo para ajustar el valor.',
  inputPassword_show: () => 'Mostrar Contraseña',
  inputPassword_hide: () => 'Ocultar contraseña',
  inputPassword_hidden: () => 'Contraseña oculta',
  formControl_clear: () => 'Borrar',
  formControl_loading: () => 'Cargando',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Longitud máxima ' + p['MAX_LENGTH'] + ' superada.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Quedan ' + p['CHARACTER_COUNT'] + ' caracteres.',
  select_noMatchesFound: () => 'No se ha encontrado ninguna coincidencia.',
  select_oneMatchFound: () => 'Se ha encontrado una coincidencia',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Se han encontrado ' + p['TOTAL_SIZE'] + ' coincidencias',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Se han encontrado ' + p['TOTAL_SIZE'] + ' coincidencias o más',
  selectMultiple_showSelectedValues: () => 'Solo se muestran los valores seleccionados.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valores seleccionados.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Casilla de control activada',
  selector_unselected: () => 'Casilla de control no activada',
  userAssistance_learnMore: () => 'Más información',
  userAssistance_required: () => 'Necesaria',
  filePicker_singleFileUploadError: () => 'Cargue los archivos de uno en uno',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'No puede cargar archivos del tipo ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'No puede cargar archivos del tipo: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'desconocido',
  filePicker_dropzonePrimaryText: () => 'Arrastrar y Soltar',
  filePicker_dropzoneSecondaryText: () => 'Seleccione un archivo o suelte uno aquí',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Seleccione o suelte archivos aquí',
  filePicker_addFiles: () => 'Agregar archivos',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Aumentar',
  inputNumber_decrease: () => 'Disminuir',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'No hay elementos para mostrar',
  message_navigationFromMessagesRegion: () =>
    'Zona de entrada de mensajes. Pulse F6 para volver al elemento enfocado anterior.',
  message_navigationToMessagesRegion: () =>
    'La zona de mensajes tiene mensajes nuevos. Pulse F6 para navegar a la zona de mensajes más reciente.',
  messageToast_allMessagesClosed: () =>
    'Se han cerrado todos los mensajes de notificación del sistema.'
};
export default bundle;
